import productData from '@/data/products.json'; // WHY DO WE HAVE 2 PRODUCTS.JSON FILES?
import optionsData from '@/data/options.json';
import { getABBucket } from "@/utils/abTest";

// import bannerData from '@/data/banner.json'

const getDefaultState = () => {
  return {
    price_label: '',
    defaultPriceLabel: 'TEFLORG',
    added: [],
    showAdded:{error:false,id:null,message:'',show:false},
    discount: '',
    affiliate: '',
    orderId: null,
    cartUser: null,
    totals: {full:0,discounted:0,due:0,paid:0},
    error:{type:'',message:'',show:false},
    status: '0',
    serverCart: {},
    cartLoading: false,
    regionClicked: '',
  }
}

const f = {
  'TEFLORG': "GBP",
  'TEFLUS': "USD",
  'IRELAND': "EUR",
  'CANADA': "CAD",
  'AUSTRALIA': "AUD",
  'SOUTHAFRICA': "ZAR"
}

export const state = () => getDefaultState()

export const mutations = {
  setPriceLabel(state, price_label) {
    console.log('Setting pricelabel', price_label)
    state.price_label = price_label
  },
  setRegionClicked(state, regionClicked) {
    console.log('Setting regionClicked', regionClicked)
    state.regionClicked = regionClicked
  },
  setDefaultPriceLabel(state, price_label) {
    console.log('Setting default pricelabel', price_label)
    state.defaultPriceLabel = price_label
  },
  addToCart(state, { id }) {
    console.log('addToCart mutation: ' ,id)
    const record = state.added.find(p => p.id === id)
    if (!record) {
      state.added.push({ id })
      state.showAdded.error = false
      state.showAdded.show = true;
      state.showAdded.id = id;
      state.showAdded.message = 'Succesfully added to cart';
    } else {
      console.log('Other addToCart error: ' ,record, id)
      state.showAdded.show = false;
      state.showAdded.id = id;
      state.showAdded.error = true
      state.showAdded.message = 'You already have this item in your cart';
    }
  },
  addToCartFree(state, { id }) {
    console.log('addToCart free mutation: ', id)
    const record = state.added.find(p => p.id === id)
    // Free products are added automatically in the background,
    // so never touch the showAdded modal state here
    if (!record) {
      state.added.push({ id })
    }
  },
  setCartError(state, data) {
    console.log('Set cart error: ' ,data)
    state.showAdded.show = false;
    state.showAdded.id = data.id;
    state.showAdded.error = true
    state.showAdded.message = data.error;
  },
  removeFromCart(state, id) {
    console.log('removing: ',id)
    state.added = state.added.filter(item => item.id !== id)
  },
  hideAdded(state) {
    state.showAdded.show = false;
    state.showAdded.error = false;
    state.showAdded.id = null;
    state.showAdded.message = '';
  },
  addDiscount(state, discount) {
    state.discount = discount
  },
  addAffiliate(state, affiliate) {
    state.affiliate = affiliate
  },
  removeDiscount(state) {
    state.discount = ''
  },
  removeAffiliate(state) {
    state.affiliate = ''
  },
  setOrderId(state,orderId) {
    state.orderId = orderId
  },
  setStatus(state,status) {
    state.status = status
  },
  setCartUser(state,userId) {
    state.cartUser = userId
  },
  setCartLoading(state,loading) {
    state.cartLoading = loading
  },
  setCartTotals(state,data) {
    console.log('totals: ',data)
    state.totals.full = data.full
    state.totals.discounted = data.discounted
    state.totals.due = data.due
    state.totals.paid = data.paid
  },
  setServerCart(state,data){
    state.serverCart = data
  },
  resetCart (state) {
    state.added = []
    state.showAdded.show = false;
    state.showAdded.error = false;
    state.showAdded.id = null;
    state.showAdded.message = '';
    state.discount = ''
    state.affiliate = ''
    state.orderId = null
    state.totals.full = 0
    state.totals.discounted = 0
    state.totals.due = 0
    state.totals.paid = 0
    state.error.type = ''
    state.error.show = false
    state.error.message = ''
    state.status = '0'
    state.serverCart = {}
    state.cartLoading = false
    state.regionClicked = ''
  },
  fullReset (state){
    Object.assign(state, getDefaultState())
  },
  setError (state,errorMessage){
    state.error.type = errorMessage.type
    state.error.show = true
    state.error.message = errorMessage.message
  },
  hideError (state){
    state.error.type = ''
    state.error.show = false
    state.error.message = ''
  }
}

export const getters = {
  getPriceLabel: state => {
    if(state.price_label !== ''){
      return state.price_label
    } else {
      return state.defaultPriceLabel
    }
  },
  getRegionClicked: state => {
    if(state.regionClicked !== ''){
      return state.regionClicked
    } else if(state.price_label !== ''){
      return state.price_label
    } else {
      return state.defaultPriceLabel
    }
  },
  getDiscount: state => {
    return state.discount.toUpperCase()
  },
  getAffiliate: state => {
    return state.affiliate.toUpperCase()
  },
  getTotals: state => {
    return state.totals
  },
  getOrderId: state => {
    return state.orderId
  },
  getStatus: state => {
    return state.status
  },
  getLoading: state => {
    return state.cartLoading
  },
  cartProducts: state => {
    return state.added.map(({ id }) => {
      const product = productData.find(p => p.id === id)
      return {
        id: product.id,
        name: product.name,
        description: product.description,
        prices: product.prices,
        type: product.type,
      }
    })
  },
  getServerCart: state => {
    return state.serverCart
  },
  showAdded: state => {
    return {
      show: state.showAdded.show,
      id: state.showAdded.id,
      message: state.showAdded.message,
      error: state.showAdded.error
    }
  },
  getErrorStatus: state => {
    console.log(
      'type: ',state.error.type,
      'show: ',state.error.show,
      'message: ',state.error.message
    )
    return {
      type: state.error.type,
      show: state.error.show,
      message: state.error.message
    }
  }
}

export const actions = {
  addToCart({commit}, product) {
    commit('addToCart', { id: product.id })
  },
  addToCartFree({commit}, product) {
    commit('addToCartFree', { id: product.id })
  },
  setCartError({commit}, data) {
    console.log('setCartError action: ',data)
    commit('setCartError', {
      id: data.id,
      error: data.error
    })
  },
  addDonation({commit}, id) {
    commit('addToCart', { id })
  },
  addDiscount({commit}, discount) {
    commit('addDiscount', discount)
  },
  addAffiliate({commit}, affiliate) {
    commit('addAffiliate', affiliate)
  },
  setPriceLabel({commit}, price_label) {
    commit('setPriceLabel', price_label)
  },
  setRegionClicked({commit}, regionClicked) {
    commit('setRegionClicked', regionClicked)
  },
  setDefaultPriceLabel({commit}, price_label) {
    commit('setDefaultPriceLabel', price_label)
  },
  setCartLoading({commit}, loading) {
    commit('setCartLoading', loading)
  },
  setCartFromParams({commit}, data) {
    const totalsData = {
      full: data.boughtProductTotal,
      discounted: data.boughtProductTotalDiscounted,
      due: data.totalDue,
      paid: data.totalPaid
    }
    commit('setCartTotals', totalsData)
    commit('setOrderId', data.id)
    commit('setPriceLabel', data.productPriceLabel)
    commit('setCartUser', data.customerId)
    // Only add chargeable products — skip zero-price bundle sub-products
    for(const boughtProduct of data.boughtProducts) {
      if(boughtProduct.productTotal > 0) {
        commit('addToCartFree', { id: boughtProduct.productId })
      }
    }
    commit('setStatus', data.status)
    commit('setServerCart', data)
  },
  updateServerCart({commit}, data) {
    commit('setServerCart', data)
  },
  resetCart({commit}) {
    console.log('Reset Cart')
    commit('resetCart')
  },
  fullReset({commit}) {
    console.log('Fully reset Cart')
    commit('fullReset')
  },
  hideError({commit}) {
    commit('hideError')
  },

  // SERVER CALLS

  // Create cart on server
  async createCartServer({ commit }){
    console.log('Create cart on server called')
    commit('hideError')
    const cartData = {
      product_price_label: this.state.cart.price_label !== '' ? this.state.cart.price_label : this.state.cart.defaultPriceLabel
    };

    if(this.state.user.user_id !== ''){
      console.log('User ID exists')
      cartData.customer_id = this.state.user.user_id

      try {
        const result = await this.$axios.$post(
          process.env.DATA_URL + '/orders/create/',
          cartData
        )
        console.log('create cart with customer: ',result)
        commit('setOrderId', result.id)
        commit('setCartUser', result.customer_id)
        return result
      } catch (error) {
        const errorMessage = { type: 'cart', message: error.response.data }
        commit('setError', errorMessage)
        return error.response.data
      }

    } else {
      console.log('No User ID')
      try {
        const result = await this.$axios.$post(
          process.env.DATA_URL + '/orders/create/no-customer/',
          cartData
        )
        console.log('create cart without customer: ',result)
        commit('setOrderId', result.id)
        return result
      } catch (error) {
        const errorMessage = { type: 'cart', message: error.response.data }
        commit('setError', errorMessage)
        return error.response.data
      }
    }
  },

  // Get cart from server
  async getCartServer({ commit }){
    console.log('Get cart on server called')
    commit('hideError')
    const orderId = this.state.cart.orderId;

    try {
      const result = await this.$axios.$get(
        process.env.DATA_URL + '/orders/get/'+orderId
      )
      console.log('get cart from server: ',result)
      commit('setServerCart', result)
      return result
    } catch (error) {
      const errorMessage = { type: 'cart', message: error.response.data }
      commit('setError', errorMessage)
      return error.response.data
    }
  },

  async addProductToCart({ dispatch, commit }, data){
    localStorage.removeItem('tefl_cs_store')
    console.log('addProductToCart',data)
    const isBundle = data.isBundle
    const orderId = data.cartData.order_id;
    const priceData = data.priceData
    const cartData = data.cartData
    const url = isBundle ? process.env.DATA_URL + '/orders/add_bundle/' : process.env.DATA_URL + '/orders/add_product/'

    try {
      const result = await this.$axios.$post(url, cartData)
      console.log('Add to cart on server: ',result)
      // was: await dispatch('addToCart', priceData.product)
      if (priceData.silent) {
        await dispatch('addToCartFree', priceData.product) // background add, no modal
      } else {
        await dispatch('addToCart', priceData.product)
      }
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.totalDue,
        paid: data.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)

      // TRACKING
      if (window) {
        const abBucket = getABBucket();
        const currencyCode = f[this.state.cart.price_label]
        const pricing = priceData.pricesDiscounted.filter(price => price.label === this.state.cart.price_label)
        console.log('PRICING',pricing)
        if(pricing.length === 0){
          pricing.push(priceData.pricesDiscounted.find(price => price.label === 'DEFAULT'))
        }
        const trackingData = {
          "product_id": priceData.product.id,
          "sku": priceData.sku,
          "category": priceData.product.type,
          "name": priceData.product.name,
          "price": pricing[0].cost,
          "discount": pricing[0].discountAmount,
          "quantity": 1,
          "coupon": priceData.offerCode,
          "currency": currencyCode,
          ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
        }
        const trackingDataGTM = {
          "item_id": priceData.product.id,
          "sku": priceData.sku,
          "item_category": priceData.product.type,
          "item_name": priceData.product.name,
          "price": pricing[0].cost,
          "discount": pricing[0].discountAmount,
          "quantity": 1,
          "coupon": priceData.offerCode,
          ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
        }
        const items = []
        items.push(trackingDataGTM)

        this.$gtm.push({
          event: "add_to_cart",
          ecommerce: {
            currency: currencyCode,
            value: pricing[0].cost,
            items
          }
        })
        this.$rs.track("Product Added", trackingData)
      }

      // Add free product if one is included in offer and not already in cart
      const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
      const FP = this.state.cart.added.find(p => p.id === Number(optionsData.freeproduct_id))
      if (
        (FPCourses.length === 0 || FPCourses.includes(priceData.product.id)) &&
        optionsData.free_offer === '1' &&
        optionsData.freeproduct_id &&
        (priceData.product.type.includes('course') || priceData.product.type.includes('bundle')) &&
        !FP
      ) {
        commit('setCartLoading', true)
        const freeproductData = {
          order_id: orderId,
          product_id: Number(optionsData.freeproduct_id),
          subProduct: true
        }
        const productId = { id: Number(optionsData.freeproduct_id) }
        
        const freeResult = await this.$axios.$post(
          process.env.DATA_URL + '/orders/add_product/',
          freeproductData
        )
        console.log('Adding free product...', freeproductData)
        await dispatch('addToCartFree', productId)
        const freeTotalsData = {
          full: freeResult.boughtProductTotal,
          discounted: freeResult.boughtProductTotalDiscounted,
          due: freeResult.totalDue,
          paid: data.totalPaid
        }
        commit('setCartLoading', false)
        commit('setCartTotals', freeTotalsData)
        commit('setServerCart', freeResult)
      }

      // Only auto-apply if the discount isn't already on the order
      const discountAlreadyApplied = result.discount && 
          result.discount.code.toUpperCase() === priceData.offerCode.toUpperCase();

      if(priceData.offerCode !== '' && priceData.offerCode !== 'PDFBUNDLE90' && !discountAlreadyApplied) {
          console.log('Auto-applying discount...',priceData.offerCode)
          await dispatch('addDiscountServer', priceData.offerCode);
      }
      
      // Check if 20100 is the only chargeable product on the server-side order
      const SOLO_PRODUCT_ID = 20100;
      const chargeableProducts = result.boughtProducts.filter(bp => bp.productTotal > 0);
      const isSoloInCart = chargeableProducts.length === 1 && chargeableProducts[0].productId === SOLO_PRODUCT_ID;

      console.log('chargeable products:', chargeableProducts.map(bp => ({ id: bp.productId, total: bp.productTotal })));
      console.log('isSoloInCart:', isSoloInCart);

      if (isSoloInCart && !discountAlreadyApplied) {
          await dispatch('addDiscountServer', 'PDFBUNDLE90');
      }

      commit('setCartLoading', false)
      return result

    } catch (error) {
      console.log('Add to cart error: ',error)
      await dispatch('setCartError',{
        id: priceData.product.id,
        error: error.response.data
      })
      return error.response.data
    }
  },

  // Add to cart on server
  async addToCartServer({ dispatch, commit }, priceData){
    localStorage.removeItem('tefl_cs_store')
    console.log('Add to cart on server called',priceData)
    console.log('classroom',priceData.product.classroomId)
    console.log('relId',priceData.product.relId)
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;
    const productId = priceData.product.id
    const classroomId = priceData.product.classroomId
    const relativeOrderBoughtProductId = priceData.product.relId

    const classroomArray = [10192,10161,10166,10171]
    let hasClassroom = false
    const isBundle = priceData.product.isBundle
    const productArray = []
    const data = {}
    data.isBundle = false;

    const cartData = {
      order_id: orderId,
      product_id: productId
    };

    if(isBundle){
      productArray.push(cartData)
      priceData.product.bundleProducts.forEach((bundleProduct) => {
        const bundleCartData = {
          order_id: orderId,
          product_id: bundleProduct
        };
        if (classroomArray.includes(bundleProduct)) {
          hasClassroom = true
        }
        productArray.push(bundleCartData)
      })
    }

    if (relativeOrderBoughtProductId !== null) {
      cartData.relative_order_bought_product_id = relativeOrderBoughtProductId;
    }

    if (classroomId !== null) {
      cartData.classroom_id = classroomId;
    }

    if (isBundle && hasClassroom) {
      cartData.classroom_id = Number(optionsData.flexible_id);
    }

    if(priceData.voucherData !== undefined){
      console.log('Gift voucher added!')
      cartData.voucher_name = priceData.voucherData.voucher_name
      cartData.voucher_email = priceData.voucherData.voucher_email
      cartData.voucher_message = priceData.voucherData.voucher_message
      cartData.voucher_date = priceData.voucherData.voucher_date
      cartData.voucher_sender = priceData.voucherData.voucher_sender
    }

    const record = this.state.cart.added.find(p => p.id === productId)
    console.log('record: ',record)

    if (!record) {

      if(orderId !== null){
        
        console.log('Order ID exists')

        if(productArray.length > 0){
          data.isBundle = true
          data.cartData = cartData
          data.priceData = priceData
          await dispatch('addProductToCart', data)
        } else {
          data.cartData = cartData
          data.priceData = priceData
          await dispatch('addProductToCart', data)
        }

      } else {

        console.log('No order ID')
        const orderCreated = await dispatch('createCartServer')
        cartData.order_id = orderCreated.id
        
        if(productArray.length > 0){
          data.isBundle = true
          data.cartData = cartData
          data.priceData = priceData
          await dispatch('addProductToCart', data)
        } else {
          data.cartData = cartData
          data.priceData = priceData
          await dispatch('addProductToCart', data)
        }
      }
    
    } else {
      console.log('Item already in cart',priceData.product.id)
      await dispatch('addToCart', priceData.product)
    }
  },

  async removeProductFromCart({dispatch, commit}, data){
    localStorage.removeItem('tefl_cs_store')
    console.log('removeProductFromCart',data)
    const cartData = data
    const productId = data.product_id
    const orderId = data.order_id
    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/remove_product/',
        cartData
      )
      console.log('Remove from cart on server: ',result,productId)
      commit('removeFromCart', productId)
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.totalDue,
        paid: data.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)

      // TRACKING
      this.$rs.track("Product Removed", {
        "product_id": productId,
        "sku": productId,
        "quantity": 1,
      })
      this.$gtm.push({
        event: "remove_from_cart",
        data: {
          "product_id": productId,
          "sku": productId,
          "quantity": 1,
        }
      })

      // Remove free product if already in cart
      const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
      const FP = this.state.cart.added.find(p => p.id === Number(optionsData.freeproduct_id))
      if (
        (FPCourses.length === 0 || FPCourses.includes(productId)) &&
        optionsData.free_offer === '1' &&
        optionsData.freeproduct_id &&
        FP
      ) {
        commit('setCartLoading', true)
        const freeproductData = {
          order_id: orderId,
          product_id: Number(optionsData.freeproduct_id),
        }
        const freeProductId = Number(optionsData.freeproduct_id);
        
        const freeResult = await this.$axios.$post(
          process.env.DATA_URL + '/orders/remove_product/',
          freeproductData
        )
        console.log('Removing free product...', freeproductData)
        commit('removeFromCart', freeProductId)
        const freeTotalsData = {
          full: freeResult.boughtProductTotal,
          discounted: freeResult.boughtProductTotalDiscounted,
          due: freeResult.totalDue,
          paid: data.totalPaid
        }
        commit('setCartLoading', false)
        commit('setCartTotals', freeTotalsData)
        commit('setServerCart', freeResult)
        return freeResult
      }

      commit('setCartLoading', false)
      return result

    } catch (error) {
      const errorMessage = { type: 'cart', message: error.response.data }
      commit('setError', errorMessage)
      return error.response.data
    }
  },

  // Remove from cart on server
  async removeFromCartServer({ dispatch, commit }, product){
    console.log('Remove from cart',product)
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    const orderId = this.state.cart.orderId;
    const productId = product.id

    const cartData = {
      order_id: orderId,
      product_id: productId,
    };

    await dispatch('removeProductFromCart', cartData)

    // No need to manually reapply discounts — the server recalculates automatically
  },

  // Assign user to cart on server
  async assignCartServer({ commit }){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    const orderId = this.state.cart.orderId;
    const customerId = this.state.user.user_id;

    if(orderId != null){
      const cartData = {
        order_id: orderId,
        customer_id: customerId,
      };

      try {
        const result = await this.$axios.$post(
          process.env.DATA_URL + '/orders/assign/',
          cartData
        )
        console.log('Assign cart on server: ',result)
        commit('setCartUser', result.customer_id)
        commit('setServerCart', result)
        return result
      } catch (error) {
        const errorMessage = { type: 'cart', message: error.response.data }
        commit('setError', errorMessage)
        return error.response.data
      }

    } else {
      return 'No order to assign'
    }
  },

  // Use a gift voucher
  async applyGiftVoucher({ dispatch, commit }, voucherCode){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;

    const cartData = {
      order_id: orderId,
      voucher_code: voucherCode
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/add_voucher/',
        cartData
      )
      if (window) {
        this.$rs.track("Coupon Entered", {
          order_id: cartData.order_id,
          cart_id: cartData.order_id,
          coupon_id: cartData.voucher_code,
        })
      }
      console.log('Add gift voucher on server: ',result)
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.totalDue,
        paid: result.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)

      if (window) {
        this.$rs.track("Coupon Applied", {
          order_id: orderId,
          cart_id: orderId,
          coupon_id: voucherCode,
          coupon_name: voucherCode,
          discount: result.boughtProductTotal - result.boughtProductTotalDiscounted
        })
      }
      commit('setCartLoading', false)
      return result

    } catch (error) {
      console.log('voucher error: ',error)
      const errorMessage = { type: 'discount', message: error.response.data }
      if (window) {
        this.$rs.track("Coupon Denied", {
          order_id: orderId,
          cart_id: orderId,
          coupon: voucherCode,
          reason: errorMessage.message
        })
      }
      commit('setCartLoading', false)
      return error.response.data
    }
  },

  // Add discount on server
  async addDiscountServer({ dispatch, commit }, discountCode){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;

    const cartData = {
      order_id: orderId,
      discount_code: discountCode
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/add_discount/',
        cartData
      )
      if (window) {
        this.$rs.track("Coupon Entered", {
          order_id: cartData.order_id,
          cart_id: cartData.order_id,
          coupon_id: cartData.discount_code,
        })
      }
      console.log('Add discount on server: ',result)
      await dispatch('addDiscount', discountCode)
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.totalDue,
        paid: result.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)

      // Add free product if applicable
      if(discountCode.toUpperCase() === 'PODCAST' || discountCode.toUpperCase() === 'GOABROAD') {
        commit('setCartLoading', true)
        const freeproductData = {
          order_id: cartData.order_id,
          product_id: Number(optionsData.freeproduct_id),
        }
        const productId = { id: Number(optionsData.freeproduct_id) }

        const freeResult = await this.$axios.$post(
          process.env.DATA_URL + '/orders/add_product/',
          freeproductData
        )
        console.log('Adding free product...', freeproductData)
        await dispatch('addToCartFree', productId)
        const freeTotalsData = {
          full: freeResult.boughtProductTotal,
          discounted: freeResult.boughtProductTotalDiscounted,
          due: freeResult.totalDue,
          paid: result.totalPaid
        }
        commit('setCartLoading', false)
        commit('setCartTotals', freeTotalsData)
        commit('setServerCart', freeResult)
      }

      if (window) {
        this.$rs.track("Coupon Applied", {
          order_id: orderId,
          cart_id: orderId,
          coupon_id: discountCode,
          coupon_name: discountCode,
          discount: result.boughtProductTotal - result.boughtProductTotalDiscounted
        })
      }
      commit('setCartLoading', false)
      return result

    } catch (error) {
      console.log('discount error: ',error)
      const errorMessage = { type: 'discount', message: error.response.data }
      commit('setError', errorMessage)
      if (window) {
        this.$rs.track("Coupon Denied", {
          order_id: orderId,
          cart_id: orderId,
          coupon: discountCode,
          reason: errorMessage.message
        })
      }
      commit('setCartLoading', false)
      return error.response.data
    }
  },

  // Add affiliate code on server
  async addAffiliateServer({ dispatch, commit }, discountCode){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;

    const cartData = {
      order_id: orderId,
      discount_code: discountCode
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/add_affiliate/',
        cartData
      )
      if (window) {
        this.$rs.track("Affiliate Code Entered", {
          order_id: cartData.order_id,
          cart_id: cartData.order_id,
          affiliate_code: cartData.discount_code,
        })
      }
      console.log('Add affiliate on server: ',result)
      await dispatch('addAffiliate', discountCode)
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.totalDue,
        paid: result.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)

      if (window) {
        this.$rs.track("Coupon Applied", {
          order_id: orderId,
          cart_id: orderId,
          coupon_id: discountCode,
          coupon_name: discountCode,
          discount: result.boughtProductTotal - result.boughtProductTotalDiscounted
        })
      }
      commit('setCartLoading', false)
      return result

    } catch (error) {
      console.log('discount error: ',error)
      const errorMessage = { type: 'discount', message: error.response.data }
      commit('setError', errorMessage)
      if (window) {
        this.$rs.track("Coupon Denied", {
          order_id: orderId,
          cart_id: orderId,
          coupon: discountCode,
          reason: errorMessage.message
        })
      }
      commit('setCartLoading', false)
      return error.response.data
    }
  },

  // Switch to combined course when upgrading
  async switchProductServer({ dispatch, commit }, priceData){
    localStorage.removeItem('tefl_cs_store')
    console.log('currentProduct',priceData.currentProductId)
    console.log('Add to cart on server called',priceData)
    console.log('classroom',priceData.product.classroomId)
    console.log('relId',priceData.product.relId)
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;
    const productId = priceData.product.id;
    const affiliateCode = this.state.cart.affiliate.toUpperCase();

    const newProduct = { id: productId };
    const removeProduct = { id: priceData.currentProductId };
    const classroomId = priceData.product.classroomId
    const relativeOrderBoughtProductId = priceData.product.relId

    const cartData = {
      order_id: orderId,
      product_id: newProduct.id
    };

    if (relativeOrderBoughtProductId !== null) {
      cartData.relative_order_bought_product_id = relativeOrderBoughtProductId;
    }
    if (classroomId !== null) {
      cartData.classroom_id = classroomId;
    }

    const removeCartData = {
      order_id: orderId,
      product_id: removeProduct.id
    };

    const record = this.state.cart.added.find(p => p.id === productId)
    console.log('record: ',record)

    if (!record) {
      if(orderId !== null){

        try {
          const result = await this.$axios.$post(
            process.env.DATA_URL + '/orders/remove_product/',
            removeCartData
          )
          console.log('Remove from cart on server: ',result,removeProduct.id)
          commit('removeFromCart', removeProduct.id)
          const totalsData = {
            full: result.boughtProductTotal,
            discounted: result.boughtProductTotalDiscounted,
            due: result.totalDue,
            paid: result.totalPaid
          }
          commit('setCartTotals', totalsData)
          commit('setServerCart', result)
        } catch (error) {
          const errorMessage = { type: 'cart', message: error.response.data }
          commit('setError', errorMessage)
        }

        console.log('Product removed, adding new one', removeProduct)
        console.log('Order ID exists')

        try {
          const result = await this.$axios.$post(
            process.env.DATA_URL + '/orders/add_product/',
            cartData
          )
          console.log('Add to cart on server: ',result)
          await dispatch('addToCart', newProduct)
          const totalsData = {
            full: result.boughtProductTotal,
            discounted: result.boughtProductTotalDiscounted,
            due: result.totalDue,
            paid: result.totalPaid
          }
          commit('setCartTotals', totalsData)
          commit('setServerCart', result)

          localStorage.setItem('tefl_upgrade', JSON.stringify(priceData.product.id))

          // TRACKING
          if (window) {
            const abBucket = getABBucket();
            const currencyCode = f[this.state.cart.price_label]
            const pricing = priceData.pricesDiscounted.filter(price => price.label === this.state.cart.price_label) || [priceData.price]
            const trackingData = {
              "product_id": priceData.product.id,
              "sku": priceData.sku,
              "category": priceData.product.type,
              "name": priceData.product.name,
              "price": pricing[0].cost,
              "discount": pricing[0].discountAmount,
              "quantity": 1,
              "coupon": priceData.offerCode,
              "currency": currencyCode,
              ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
            }
            const trackingDataGTM = {
              "item_id": priceData.product.id,
              "sku": priceData.sku,
              "item_category": priceData.product.type,
              "item_name": priceData.product.name,
              "price": pricing[0].cost,
              "discount": pricing[0].discountAmount,
              "quantity": 1,
              "coupon": priceData.offerCode,
              ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
            }
            const items = []
            items.push(trackingDataGTM)

            this.$rs.track("Product Added", trackingData)
            // this.$gtm.push({ event: "add_to_cart", currency: currencyCode, value: pricing[0].cost, items })
            this.$gtm.push({ event: "add_to_cart", ecommerce: { currency: currencyCode, value: pricing[0].cost, items} })
            this.$rs.track("Course Upgraded")
            this.$gtm.push({ event: "120_upgrade" })
          }

          // Add free product if applicable
          const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
          const FP = this.state.cart.added.find(p => p.id === Number(optionsData.freeproduct_id))
          if (
            (FPCourses.length === 0 || FPCourses.includes(priceData.product.id)) &&
            optionsData.free_offer === '1' &&
            optionsData.freeproduct_id &&
            (priceData.product.type.includes('course') || priceData.product.type.includes('bundle')) &&
            !FP
          ) {
            commit('setCartLoading', true)
            const freeproductData = {
              order_id: orderId,
              product_id: Number(optionsData.freeproduct_id),
              subProduct: true
            }
            const freeProductId = { id: Number(optionsData.freeproduct_id) }
            const freeResult = await this.$axios.$post(
              process.env.DATA_URL + '/orders/add_product/',
              freeproductData
            )
            console.log('Adding free product...', freeproductData)
            await dispatch('addToCartFree', freeProductId)
            const freeTotalsData = {
              full: freeResult.boughtProductTotal,
              discounted: freeResult.boughtProductTotalDiscounted,
              due: freeResult.totalDue,
              paid: result.totalPaid
            }
            commit('setCartLoading', false)
            commit('setCartTotals', freeTotalsData)
            commit('setServerCart', freeResult)
          }

          // Only reapply if not already on the order
          const discountAlreadyApplied = result.discount &&
              result.discount.code.toUpperCase() === priceData.offerCode.toUpperCase();

          const affiliateAlreadyApplied = result.affiliate &&
              result.affiliate.code.toUpperCase() === affiliateCode.toUpperCase();

          if(priceData.offerCode !== '' && !discountAlreadyApplied) await dispatch('addDiscountServer', priceData.offerCode);
          if(affiliateCode !== '' && !affiliateAlreadyApplied) await dispatch('addAffiliateServer', affiliateCode);

          commit('setCartLoading', false)
          return result

        } catch (error) {
          console.log('Add to cart error: ',error)
          await dispatch('setCartError',{
            id: priceData.product.id,
            error: error.response.data
          })
          return error.response.data
        }
      }
    
    } else {
      console.log('Item already in cart',priceData.product.id)
      await dispatch('addToCart', priceData.product)
    }
  },

  // Revert to original course when downgrading
  async revertProductServer({ dispatch, commit }, priceData){
    localStorage.removeItem('tefl_cs_store')
    console.log('currentProduct',priceData.currentProductId)
    console.log('Add to cart on server called',priceData)
    console.log('classroom',priceData.product.classroomId)
    console.log('relId',priceData.product.relId)
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;
    const productId = priceData.product.id;
    const affiliateCode = this.state.cart.affiliate.toUpperCase();

    const newProduct = { id: productId };
    const removeProduct = { id: priceData.currentProductId };
    const classroomId = priceData.product.classroomId
    const relativeOrderBoughtProductId = priceData.product.relId

    const cartData = {
      order_id: orderId,
      product_id: newProduct.id
    };

    if (relativeOrderBoughtProductId !== null) {
      cartData.relative_order_bought_product_id = relativeOrderBoughtProductId;
    }
    if (classroomId !== null) {
      cartData.classroom_id = classroomId;
    }

    const removeCartData = {
      order_id: orderId,
      product_id: removeProduct.id
    };

    const record = this.state.cart.added.find(p => p.id === productId)
    console.log('record: ',record)

    if (!record) {
      if(orderId !== null){

        try {
          const result = await this.$axios.$post(
            process.env.DATA_URL + '/orders/remove_product/',
            removeCartData
          )
          console.log('Remove from cart on server: ',result,removeProduct.id)
          commit('removeFromCart', removeProduct.id)
          const totalsData = {
            full: result.boughtProductTotal,
            discounted: result.boughtProductTotalDiscounted,
            due: result.totalDue,
            paid: result.totalPaid
          }
          commit('setCartTotals', totalsData)
          commit('setServerCart', result)
        } catch (error) {
          const errorMessage = { type: 'cart', message: error.response.data }
          commit('setError', errorMessage)
        }

        console.log('Product removed, adding new one', removeProduct)
        console.log('Order ID exists')

        try {
          const result = await this.$axios.$post(
            process.env.DATA_URL + '/orders/add_product/',
            cartData
          )
          console.log('Add to cart on server: ',result)
          await dispatch('addToCart', newProduct)
          const totalsData = {
            full: result.boughtProductTotal,
            discounted: result.boughtProductTotalDiscounted,
            due: result.totalDue,
            paid: result.totalPaid
          }
          commit('setCartTotals', totalsData)
          commit('setServerCart', result)

          localStorage.removeItem('tefl_upgrade')

          // TRACKING
          if (window) {
            const abBucket = getABBucket();
            const currencyCode = f[this.state.cart.price_label]
            const pricing = priceData.pricesDiscounted.filter(price => price.label === this.state.cart.price_label) || [priceData.price]
            const trackingData = {
              "product_id": priceData.product.id,
              "sku": priceData.sku,
              "category": priceData.product.type,
              "name": priceData.product.name,
              "price": pricing[0].cost,
              "discount": pricing[0].discountAmount,
              "quantity": 1,
              "coupon": priceData.offerCode,
              "currency": currencyCode,
              ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
            }
            const trackingDataGTM = {
              "item_id": priceData.product.id,
              "sku": priceData.sku,
              "item_category": priceData.product.type,
              "item_name": priceData.product.name,
              "price": pricing[0].cost,
              "discount": pricing[0].discountAmount,
              "quantity": 1,
              "coupon": priceData.offerCode,
              ...(abBucket && { "ab_bucket": abBucket }), // only include if assigned
            }
            const items = []
            items.push(trackingDataGTM)

            this.$rs.track("Product Added", trackingData)
            // this.$gtm.push({ event: "add_to_cart", currency: currencyCode, value: pricing[0].cost, items })
            this.$gtm.push({ event: "add_to_cart", ecommerce: { currency: currencyCode, value: pricing[0].cost, items} })
            this.$rs.track("Course downgraded")
            this.$gtm.push({ event: "120_downgrade" })
          }

          // Add free product if applicable
          const FPCourses = optionsData.freeproduct_array ? JSON.parse(optionsData.freeproduct_array) : [];
          const FP = this.state.cart.added.find(p => p.id === Number(optionsData.freeproduct_id))
          if (
            (FPCourses.length === 0 || FPCourses.includes(priceData.product.id)) &&
            optionsData.free_offer === '1' &&
            optionsData.freeproduct_id &&
            (priceData.product.type.includes('course') || priceData.product.type.includes('bundle')) &&
            !FP
          ) {
            commit('setCartLoading', true)
            const freeproductData = {
              order_id: orderId,
              product_id: Number(optionsData.freeproduct_id),
              subProduct: true
            }
            const freeProductId = { id: Number(optionsData.freeproduct_id) }
            const freeResult = await this.$axios.$post(
              process.env.DATA_URL + '/orders/add_product/',
              freeproductData
            )
            console.log('Adding free product...', freeproductData)
            await dispatch('addToCartFree', freeProductId)
            const freeTotalsData = {
              full: freeResult.boughtProductTotal,
              discounted: freeResult.boughtProductTotalDiscounted,
              due: freeResult.totalDue,
              paid: result.totalPaid
            }
            commit('setCartLoading', false)
            commit('setCartTotals', freeTotalsData)
            commit('setServerCart', freeResult)
          }

          // Only reapply if not already on the order
          const discountAlreadyApplied = result.discount &&
              result.discount.code.toUpperCase() === priceData.offerCode.toUpperCase();

          const affiliateAlreadyApplied = result.affiliate &&
              result.affiliate.code.toUpperCase() === affiliateCode.toUpperCase();

          if(priceData.offerCode !== '' && !discountAlreadyApplied) await dispatch('addDiscountServer', priceData.offerCode);
          if(affiliateCode !== '' && !affiliateAlreadyApplied) await dispatch('addAffiliateServer', affiliateCode);

          commit('setCartLoading', false)
          return result

        } catch (error) {
          console.log('Add to cart error: ',error)
          await dispatch('setCartError',{
            id: priceData.product.id,
            error: error.response.data
          })
          return error.response.data
        }
      }
    
    } else {
      console.log('Item already in cart',priceData.product.id)
      await dispatch('addToCart', priceData.product)
    }
  },

  // Remove discount on server
  async removeDiscountServer({ commit }, discountCode){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;

    const cartData = { order_id: orderId };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/remove_discount/',
        cartData
      )
      console.log('Remove discount on server: ',result)
      commit('removeDiscount')
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.boughtProductTotalDiscounted - result.totalPaid,
        paid: result.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)
      if (window) {
        this.$rs.track("Coupon Removed", {
          order_id: orderId,
          cart_id: orderId,
          coupon_id: discountCode,
          coupon_name: discountCode,
          discount: result.boughtProductTotal - result.boughtProductTotalDiscounted
        })
      }
      commit('setCartLoading', false)
      return result

    } catch (error) {
      const errorMessage = { type: 'discount', message: error.response.data }
      commit('setError', errorMessage)
      commit('setCartLoading', false)
      return error.response.data
    }
  },

  // Remove affiliate on server
  async removeAffiliateServer({ commit }, discountCode){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    const orderId = this.state.cart.orderId;

    const cartData = { order_id: orderId };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/remove_affiliate/',
        cartData
      )
      console.log('Remove affiliate on server: ',result)
      commit('removeAffiliate')
      const totalsData = {
        full: result.boughtProductTotal,
        discounted: result.boughtProductTotalDiscounted,
        due: result.boughtProductTotalDiscounted - result.totalPaid,
        paid: result.totalPaid
      }
      commit('setCartTotals', totalsData)
      commit('setServerCart', result)
      if (window) {
        this.$rs.track("Affiliate Removed", {
          order_id: orderId,
          cart_id: orderId,
          affiliate_id: discountCode,
          affiliate_name: discountCode,
          discount: result.boughtProductTotal - result.boughtProductTotalDiscounted
        })
      }
      commit('setCartLoading', false)
      return result

    } catch (error) {
      const errorMessage = { type: 'discount', message: error.response.data }
      commit('setError', errorMessage)
      commit('setCartLoading', false)
      return error.response.data
    }
  },

  // Change the order currency on the server
  async changeCurrencyServer({ dispatch, commit }, priceLabel){
    localStorage.removeItem('tefl_cs_store')
    commit('hideError')
    commit('setCartLoading', true)
    commit('setRegionClicked', priceLabel)
    const orderId = this.state.cart.orderId;
    
    // Overwrite for ROW option
    if(priceLabel === 'ROW') priceLabel = 'TEFLUS'
    // Overwrite for EU option
    if(priceLabel === 'EU') priceLabel = 'IRELAND'

    if(orderId && this.state.cart.price_label !== priceLabel) {
      const cartData = {
        order_id: orderId,
        product_price_label: priceLabel
      };

      try {
        const result = await this.$axios.$post(
          process.env.DATA_URL + '/orders/set_product_price_label/',
          cartData
        )
        console.log('Change currency on server: ',result)
        commit('setPriceLabel', priceLabel)

        // If server removed any discount/affiliate due to currency incompatibility,
        // sync Vuex state and show messages to the customer
        if (result.currencyMessages && result.currencyMessages.length > 0) {
          result.currencyMessages.forEach(message => {
            if (message.includes('discount')) commit('removeDiscount')
            if (message.includes('affiliate')) commit('removeAffiliate')
            commit('setError', { type: 'region', message })
          })
        }

        const totalsData = {
          full: result.boughtProductTotal,
          discounted: result.boughtProductTotalDiscounted,
          due: result.boughtProductTotalDiscounted - result.totalPaid,
          paid: result.totalPaid
        }
        commit('setCartTotals', totalsData)
        commit('setServerCart', result)

        this.$rs.track("Region Changed", { priceLabel })
        commit('setCartLoading', false)

        const pathName = window.location.pathname;
        if(pathName === '/' && this.state.user.userRegion === 'en-us'){
          window.location.pathname = '/en-us/';
        }
        else if(pathName === '/en-us/' && this.state.user.userRegion === 'en'){
          window.location.pathname = '/';
        }

      } catch (error) {
        const errorMessage = { type: 'region', message: error.response.data }
        commit('setError', errorMessage)
        commit('setCartLoading', false)
        return error.response.data
      }

    } else {
      commit('setPriceLabel', priceLabel)
      commit('setCartLoading', false)
      const pathName = window.location.pathname;
      if(pathName === '/' && this.state.user.userRegion === 'en-us'){
        window.location.pathname = '/en-us/';
      }
      else if(pathName === '/' && this.state.user.userRegion === 'ie'){
        window.location.pathname = '/ie/';
      }
      else if(pathName === '/en-us/' && this.state.user.userRegion === 'en'){
        window.location.pathname = '/';
      }
      else if(pathName === '/en-us/' && this.state.user.userRegion === 'ie'){
        window.location.pathname = '/ie/';
      }
      else if(pathName === '/ie/' && this.state.user.userRegion === 'en'){
        window.location.pathname = '/';
      }
      else if(pathName === '/ie/' && this.state.user.userRegion === 'en-us'){
        window.location.pathname = '/en-us/';
      }
    }
  },
}